export const TRANSLATION_MY_PLAN = {
  cards: {
    benefits: {
      title: 'my_plan.cards.benefits.title',
      description: 'my_plan.cards.benefits.description',
      button: 'my_plan.cards.benefits.button',
      bulletPoints: {
        benefit: 'my_plan.cards.benefits.bullet_points.benefit',
        journey: 'my_plan.cards.benefits.bullet_points.journey',
        bfu: 'my_plan.cards.benefits.bullet_points.bfu',
        bfuPlural: 'my_plan.cards.benefits.bullet_points.bfu_plural'
      },
      with: 'my_plan.cards.benefits.with',
      moreInfo: 'my_plan.cards.benefits.more_info'
    },
    protection: {
      title: 'global.health.main',
      description: 'my_plan.health_benefits.card.description',
      button: 'global.add_protection.main'
    },
    benefit: {
      title: 'global.benefits',
      description: 'my_plan.benefits.card.description',
      button: 'global.add_benefits.main',
      bfuTitle: 'my_plan.benefits.flexible_benefits.card'
    },
    support: {
      title: 'my_plan.buddy_help.title',
      description: 'my_plan.buddy_help.description'
    },
    insight: {
      title: 'my_plan.wellbeing_benefit_detail.insight_card.title',
      description: 'my_plan.benefit_detail.insight_card.description'
    },
    insuranceInsight: {
      title: 'my_plan.insurance_benefit_detail.insight_card.title',
      description: 'my_plan.benefit_detail.insight_card.description'
    },
    insuranceCoverages: {
      title: 'my_plan.insurance_benefit_detail.coverage_card.title',
      button: 'global.coverage_detail.main',
      totalCoverage: 'global.total_coverage.main',
      buttonTooltip: 'my_plan.insurance_benefit_detail.coverage_detail.empty.tooltip'
    }
  },
  buddyMessage: 'my_plan.buddy_help.message',
  hero: {
    title: 'global.my_plan.main',
    description: 'my_plan.hero.description',
    descriptionWithoutPlans: 'my_plan.hero.description_empty_state',
    button: 'global.upgrade_plan.main'
  },
  perCollaborator: 'global.per_collaborator.main',
  perMonth: 'global.per_month.main',
  instructionTitle: 'my_plan.wellbeing_benefit_detail.instructions_card.title',
  noPlans: {
    title: 'my_plan.empty_state.title',
    description: 'my_plan.empty_state.description',
    button: 'global.hire_plan.button'
  },
  benefitsToChoose: {
    hero: {
      title: 'global.flexible_benefits.detail',
      description: 'global.plan_included.main'
    },
    cardInsight: {
      title: 'my_plan.flexible_benefit_detail.insight_card.title',
      description: 'my_plan.flexible_benefit_detail.insight_card.description'
    },
    chooseInstruction: {
      title: 'my_plan.flexible_benefit_detail.instructions_card.title',
      step1: 'my_plan.flexible_benefit_detail.instructions_card.step_1',
      step2: 'my_plan.flexible_benefit_detail.instructions_card.step_2',
      step3: 'my_plan.flexible_benefit_detail.instructions_card.step_3',
      step4: 'my_plan.flexible_benefit_detail.instructions_card.step_4'
    }
  }
};
